import React from 'react';
import { OrderTimelineStep } from '../orderDetailsTypes';
import styles from './OrderTimeline.module.css';

interface OrderTimelineProps {
  steps: OrderTimelineStep[];
}

export const OrderTimeline: React.FC<OrderTimelineProps> = ({ steps }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>🕒 Order Timeline</h3>
      <ul className={styles.timeline}>
        {steps.map((step, idx) => (
          <li key={step.id} className={styles.entry}>
            <span className={`${styles.dot} ${styles[step.state]}`}>
              {step.state === 'completed' ? '✓' : ''}
            </span>
            {idx < steps.length - 1 && (
              <span
                className={`${styles.line} ${
                  step.state === 'completed' && steps[idx + 1].state === 'completed'
                    ? styles.lineDone
                    : ''
                }`}
              />
            )}
            <div>
              <p className={`${styles.label} ${step.state === 'pending' ? styles.muted : ''}`}>
                {step.label}
              </p>
              <p className={styles.meta}>{step.meta}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
